import PropTypes from "prop-types";
import "./styles.css";

// MUI
import { Stack } from "@mui/material";

const getAreaWidth = ({ mainSection, columns, totalColumns, separation, reduction = 0 }) => {
	let area = mainSection + columns * totalColumns + separation * 2 * totalColumns;
	if (reduction) {
		area -= reduction;
	}
	return `${area}px`;
};

export default function TierRowsItem(props) {
	const {
		children,
		hasShadow = false,
		spaces = {
			mainSection: 190,
			columns: 100,
			totalColumns: 1,
			separation: 5,
			reduction: 0,
		},
		sxModifiers = null,
	} = props;

	return (
		<Stack direction="row" position="relative" sx={sxModifiers}>
			{hasShadow && <Stack className={"tier-rows-item-shadow"} width={getAreaWidth({ ...spaces })} />}
			<Stack sx={sxModifiers}>{children}</Stack>
		</Stack>
	);
}
TierRowsItem.propTypes = {
	children: PropTypes.node,
	hasShadow: PropTypes.bool,
	spaces: PropTypes.shape({
		mainSection: PropTypes.number,
		columns: PropTypes.number,
		totalColumns: PropTypes.number,
		separation: PropTypes.number,
		reduction: PropTypes.number,
	}),
	sxModifiers: PropTypes.object,
};
